import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EpeFormData } from 'app/models/application';
import { ApplicationsService } from 'app/services/applications.service';
import { SessionStorage } from 'app/storage/session.storage';

@Component({
  selector: 'app-epe-application-form',
  templateUrl: './epe-application-form.component.html'
})
export class EpeApplicationFormComponent implements OnInit {
  form!: FormGroup;
  submitting = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private applicationsService: ApplicationsService,
    private auth: SessionStorage,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      organisation: ['', Validators.required],
      organisation_type: ['', Validators.required],
      country: ['', Validators.required],
      gender: [''],
      phone_number: [''],
      position: [''],
      position_dates: [''],
      linkedin: [''],
      cv: [''],
      tell_us_more: [''],
      website_publication: [false],
      title: [''],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    this.submitting = true;
    const formData: EpeFormData = {
      ...this.form.value,
      topics: [],
      standardisation_roles: [],
      academic_qualifications: [],
      previous_positions: [],
    };
    this.applicationsService.create(this.auth.userId!, 'epe', formData).subscribe({
      next: () => this.router.navigate(['/my-applications']),
      error: (err) => {
        this.errorMessage = err?.error?.message || 'Errore durante l\'invio. Riprova.';
        this.submitting = false;
      }
    });
  }
}
